import {AnyAction} from 'redux'
import {changeEventAction} from '../actions/event'
import {GET_POLICIES_OLD, TOGGLE_AGREE_POLICIES_OLD, getPolicies, toggleAgreePolicies} from '../actions/policies'
import {SEND_RSVP_OLD, sendRsvp} from '../actions/rsvp'
import {PoliciesState} from '../types/state'

const defaultState: PoliciesState = {
  agreed: false,
  showAlert: false,
  policies: [],
}

export const policies = (state: PoliciesState = defaultState, action: AnyAction) => {
  switch (action.type) {
    case changeEventAction.toString():
      return {
        ...defaultState,
        ...action.payload.policies,
      }
    case TOGGLE_AGREE_POLICIES_OLD:
    case toggleAgreePolicies.toString():
      return {
        ...state,
        agreed: !state.agreed,
      }
    case GET_POLICIES_OLD.REQUEST:
      return {
        ...state,
        showAlert: action.args[1].showAlert,
        agreed: false,
      }
    case getPolicies.pending.toString(): {
      const showAlert = action.meta.arg.showAlert

      return {
        ...state,
        showAlert,
        agreed: false,
      }
    }
    case GET_POLICIES_OLD.SUCCESS:
      return {
        ...state,
        ...action.payload,
        agreed: false,
        showAlert: action.args[1].showAlert,
      }
    case getPolicies.fulfilled.toString(): {
      const showAlert = action.meta.arg.showAlert

      return {
        ...state,
        ...action.payload,
        agreed: false,
        showAlert,
      }
    }
    case SEND_RSVP_OLD.FAILURE:
    case sendRsvp.rejected.toString():
      return {
        ...state,
        agreed: false,
      }
    default:
      return state
  }
}
